import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const AddRoleFormSchema = z.object({
  roleNumber: z.number().optional(),
  roleName: z.string().min(2, 'Role name must be at least 2 characters').max(100),
  roleDescription: z.string().max(500).optional().default(''),
  roleType: z.enum(['user', 'workload'], { message: 'Role type must be user or workload' }),
  namespace: z.enum(['cnx', 'frg'], { message: 'Namespace must be cnx or frg' }),
  organization: z.string().min(1, 'Organization is required').max(100),
})

export type AddRoleFormData = z.infer<typeof AddRoleFormSchema>

export function transformToApiRequest(formData: AddRoleFormData) {
  return {
    roleNumber: formData.roleNumber,
    roleName: formData.roleName.trim(),
    roleDescription: formData.roleDescription?.trim() ?? '',
    roleType: formData.roleType,
    namespace: formData.namespace,
    organization: formData.organization.trim(),
  }
}
